import { View } from 'react-native';
import TextLato from '../../../text/text-lato/TextLato';
import { ProgressBar } from '../../../progress-bar/ProgressBar';
import { observer } from 'mobx-react-lite';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import BaseModal from '../../base-modal/BaseModal';
import { useModalUploadToCart } from './ModalUploadToCart.logic';

export const ModalUploadToCart = observer(
  ({ dynamicModalVisible, type, dynamicModalLayer: { id } }: DynamicModalProps) => {
    const { activeProduct, style, title, description, handleAbort, progress } = useModalUploadToCart();

    return (
      <BaseModal
        testID={TestIDs.UPLOAD_TO_CART}
        modalWidth={460}
        closeOnClickOutside={false}
        modalIcon={
          <View style={{ width: 100, height: 100 }}>
            <Illustration name={progress === 100 ? ILLUSTRATION_NAMES.ImportSuccess : ILLUSTRATION_NAMES.Import} />
          </View>
        }
        body={
          <>
            <View style={style.barContainer}>
              <ProgressBar progress={progress} />
            </View>
            <View style={{ gap: 16 }}>
              <TextLato style={style.title}>{title}</TextLato>
              <TextLato style={style.description}>{description}</TextLato>
            </View>
          </>
        }
        onClose={activeProduct?.isCartCancellationEnabled ? handleAbort : undefined}
        onCloseOutside={handleAbort}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
